export class TextAlignment {
    constructor(value) {
        if (!TextAlignment.allowedValue.includes(value)) {
            throw new Error(
                `Text alignment instantiation failed. Tried value : ${value}.` +
                    `Allowed value : ${TextAlignment.allowedValue.join(', ')}`
            );
        }
        this.value = value;
    }
}
TextAlignment.allowedValue = ['left', 'center', 'right', 'justify-center'];
